/**
 * Copyright (c) 2024, Mint Metrics Pty Ltd All rights reserved. BSD 3-Clause License. https://github.com/mint-metrics/mojito/blob/master/LICENSE
 * Copyright (c) 2010, James Yu. https://github.com/jamesyu/cohorts/blob/master/LICENSE
 * Copyright (c) 2005-2017, JS Foundation All rights reserved. https://dojotoolkit.org/license.html
 * Copyright (c) 2011 Sebastian Tschan, https://blueimp.net
 */

var Mojito = (function () {
    // Adapted from dojo.cookie module
    var Cookies = {
        parseCookies: function () {
            var cookies = {}, i, pair, name, value, separated = document.cookie.split(';'), c = separated.length;
            for (i = 0; i < c; i++) {
                pair = separated[i].split('=');
                name = pair[0].replace(/^\s*/, '').replace(/\s*$/, '');
                value = decodeURIComponent(pair[1]) || null;
                cookies[name] = value;
            }
            return cookies;
        },
        get: function (name) {
            var c = document.cookie, ret;
            var matches = c.match(new RegExp('(?:^|; )' + this.escapeString(name) + '=([^;]*)'));
            ret = matches ? decodeURIComponent(matches[1]) : null;

            return ret;
        },
        set: function (name, value, props) {
            props = props || {};
            if (!props.path) {
                props.path = '/';
            }
            var exp = props.expires, d;
            if (typeof exp === 'number') {
                d = new Date();
                d.setTime(d.getTime() + exp * 24 * 60 * 60 * 1000);
                exp = d;
                props.expires = d;
            }

            if (exp && exp.toUTCString) {
                props.expires = exp.toUTCString();
            }

            value = encodeURIComponent(value);
            var updatedCookie = name + '=' + value,
                propName,
                propValue;

            var keys = Object.keys(props),
                i, c;
            for (i = 0, c = keys.length; i < c; i++) {
                propName = keys[i];
                updatedCookie += '; ' + propName;
                propValue = props[propName];
                if (propValue !== true) {
                    updatedCookie += '=' + propValue;
                }
            }

            document.cookie = updatedCookie;
        },
        remove: function (name) {
            document.cookie = name + '=;expires=Sat, 31 Jan 1970 16:00:00 GMT;path=/';
        },
        escapeString: function (str) {
            return str.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, function (ch) {
                return '\\' + ch;
            });
        }
    };

    var Utils = {
        waitUntil: function (conditionFunction, callback, timeout = 2000, interval = 50) {
            const start = Date.now();
            (function checkCondition() {
                if (conditionFunction()) {
                    callback();
                } else if (Date.now() - start < timeout) {
                    setTimeout(checkCondition, interval);
                }
            })();
        },
        waitForElement: function (selector, callback, timeout = 2000) {
            this.waitUntil(
                () => document.querySelector(selector),
                () => callback(document.querySelector(selector)),
                timeout
            );
        },
       observeSelector: function(e, t, n) {

                    n || (n = {});
                    var o = this;
                    if (!this.domObserver) {
                        this.listenerCount = 0, this.listeners = [];
                        var r = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
                        this.domObserver = new r(this._observeCallback.bind(this)), this.domObserver.observe(document.documentElement, {
                            childList: !0,
                            subtree: !0
                        })
                    }
                    var a = {
                        selector: e,
                        fn: t,
                        options: n,
                        index: ++this.listenerCount
                    };
                    this.listeners.push(a);
                    var s = parseInt(n.timeout, 10);
                    isNaN(s) || (a.timeoutHandle = window.setTimeout((function() {
                        o._observeTimeout(a)
                    }), s)), this._observeCallback()
                },
      _observeCallback: function() {
                    var e, t, n, i, o, r = [];
                    for (i = 0, o = this.listeners.length; i < o; i++)
                        if ((e = this.listeners[i]) && !e.executed && (t = document.querySelectorAll(e.selector)).length) {
                            if (e.options.once && !e.executed) e.executed = !0, r.push(e), e.fn(t[0]);
                            else
                                for (var a = 0, s = t.length; a < s; a++) t[a]["_observed" + e.index] || (t[a]["_observed" + e.index] = !0, e.fn(t[a]));
                            e.timeoutHandle && window.clearTimeout(e.timeoutHandle)
                        } for (i = 0, o = r.length; i < o; i++) - 1 !== (n = this.listeners.indexOf(r[i])) && this.listeners.splice(n, 1)
                },
        watchElement: function (selectorOrElement, callback, watchOptions) {
            const MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
            if (!MutationObserver) {
                console.error("MutationObserver not supported in this browser.");
                return;
            }

            var domWatcher = new MutationObserver(callback);

            if (!watchOptions) {
                watchOptions = {
                    childList: true,
                    subtree: true,
                    characterData: true,
                    attributes: true
                };
            }

            var elements;
            if (typeof selectorOrElement === "string") {
                elements = document.querySelectorAll(selectorOrElement);
            } else {
                elements = [selectorOrElement];
            }

            for (let i = 0; i < elements.length; i++) {
                domWatcher.observe(elements[i], watchOptions);
            }
        },
        domReady: (function () {
            var fns = [],
                isPageLoaded = document.readyState === 'interactive' || document.readyState === 'complete' || document.readyState === 'loaded';

            function callReady() {
                isPageLoaded = true;
                while (fns.length) {
                    fns.shift()();
                }
            }

            if (!isPageLoaded) {
                document.addEventListener('DOMContentLoaded', callReady);
            }

            function domReady(callback) {
                if (isPageLoaded) {
                    callback();
                } else {
                    fns.push(callback);
                }
            }

            return domReady;
        })()
    };
    var exitIntentCommon = {
        voucherCode: "MX893GHCLK",
        countdownTime: 300,
        callbacks: [],
        popupShown: false,
        detectExitIntent: function (callback) {
            this.callbacks.push(callback);
            Utils.domReady(() => {
                Utils.waitForElement(".total-line.total-line--subtotal span", () => {
                    this._detectExitIntent();
                });
            });
        },
        _detectExitIntent: function () {
            if (!this.intentListenerAdded) {
                this.intentListenerAdded = true;
                document.addEventListener("mouseout", (event) => {
                    if (!event.toElement && !event.relatedTarget && event.clientY < 10) {
                        this.exitIntentDetected();
                    }
                });
            }
        },
        exitIntentDetected: function () {
            if (!this.popupShown && this.shouldShowPopup()) {
                this.callbacks.forEach((callback) => callback());
                this.showPopup();
            }
        },
        shouldShowPopup: function () {
            var popupCookie = Cookies.get("exit-intent");
            return popupCookie === null;
        },
        showPopup: function () {
            if (!this.popupShown) {
                this.popupShown = true;
                this.createPopup();
            }
        },
        createPopup: function () {
            this.injectCSS();

            var popup = document.createElement("div");
            popup.className = "popup";
            popup.innerHTML = `
                <div class="popup-content">
                    <span class="close-popup">&times;</span>
                    <h2>Special Offer!</h2>
                    <p>Use this exclusive voucher code to get 5% off your purchase!</p>
                    <p class="voucher-code">${this.voucherCode}</p>
                    <button class="apply-code">Apply Code</button>
                </div>
            `;
            document.body.appendChild(popup);

            popup.querySelector(".close-popup").addEventListener("click", () => this.closePopup());
            popup.querySelector(".apply-code").addEventListener("click", () => this.applyVoucherCode());
        },
        injectCSS: function () {
            var style = document.createElement("style");
            style.textContent = `
                .popup {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background: rgba(0, 0, 0, 0.7);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    z-index: 9999;
                }
                .popup-content {
                    background: #fff;
                    padding: 20px;
                    text-align: center;
                    border-radius: 10px;
                    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
                    position: relative;
                }
                .close-popup {
                    position: absolute;
                    top: 10px;
                    right: 10px;
                    cursor: pointer;
                    font-size: 20px;
                }
                .voucher-code {
                    font-size: 18px;
                    font-weight: bold;
                    color: #333;
                    margin: 10px 0;
                }
                .apply-code {
                    background: #007BFF;
                    color: white;
                    border: none;
                    padding: 10px 20px;
                    cursor: pointer;
                    border-radius: 5px;
                }
                .apply-code:hover {
                    background: #0056b3;
                }
            `;
            document.head.appendChild(style);
        },
        closePopup: function () {
            var popup = document.querySelector(".popup");
            if (popup) {
                popup.remove();
                this.popupShown = false;
            }
        },
        applyVoucherCode: function () {
            this.closePopup();
            var inputField = document.querySelector("#checkout_reduction_code");
            if (inputField) {
                inputField.value = this.voucherCode;
                alert(`Voucher code ${this.voucherCode} applied!`);
            }
        }
    };

    return {
        Cookies: Cookies,
        utils: Utils,
        exitIntentCommon: exitIntentCommon
    };

}());
